import { PageContainer } from '@you-go-vn/components';
import { Form } from 'antd';
import ScheduleForm from './components/ScheduleForm';


export default function AddSellingSchedulePage() {

  const [form] = Form.useForm();


  return (
    <PageContainer>
      <ScheduleForm
        form={form}
      />

    </PageContainer>
  );
}
